import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment.prod";
import { CaseModel } from "../models/case.model";
import { ContactModel } from "../models/contact.model";
import { ApiService } from "./api.service";

@Injectable()
export class CaseService {

    constructor(private apiService: ApiService) {
        
    }

    getCasesForContact(model: ContactModel): Observable<any> {
        return this.apiService.post<Array<CaseModel>>('case/getcasesforcontact', model, {showToast: true});
    }
}